import React from "react";
import Styles from "./MenuDecor.module.scss";

const MenuDecor = ({src}: {src: string}) => (
	<img className={Styles.decor} src={src} alt="decor"/>
);

export default MenuDecor;